import { API_BASE_URL } from './api';
import type { CourseModule } from '../types/course';

export async function fetchModules(): Promise<CourseModule[]> {
  const response = await fetch(`${API_BASE_URL}/modules`);
  if (!response.ok) {
    throw new Error('Impossible de récupérer les modules');
  }
  return (await response.json()) as CourseModule[];
}

export async function updateModule(id: string, payload: Partial<Pick<CourseModule, 'title' | 'description' | 'color' | 'isLocked' | 'position'>>): Promise<CourseModule> {
  const response = await fetch(`${API_BASE_URL}/modules/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => undefined);
    const message = body?.message ?? 'Impossible de mettre à jour le module';
    throw new Error(Array.isArray(message) ? message.join(', ') : message);
  }

  return (await response.json()) as CourseModule;
}
